import React, { FC } from 'react';
import { Modal, Spinner } from 'react-bootstrap';

interface Props {
    showModal: boolean;
    size?: 'lg' | 'sm' | 'xl';
}

const ModalLoader: FC<Props> = ({ showModal, size = 'lg' }) => (
    <div>
        <Modal
            show={showModal}
            size={size}
            aria-labelledby="contained-modal-title-vcenter"
            centered
            className="loading-modal"
            backdrop="static"
            keyboard={false}
        >
            <Modal.Body className="d-flex flex-column align-items-center">
                <Spinner animation="border" variant="light"/>
                <p className="font-Loading">Loading....</p>
            </Modal.Body>
        </Modal>
    </div>
);
export default ModalLoader;
